import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import GlobalContext from "./context/GlobalContext";
import UnsubscriptionIterableRouter from "./pages/IterableUnsubscribe/UnsubscriptionIterableRouter";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://f49f4305c63e88325316e2db9830398b@o4508122319552512.ingest.de.sentry.io/4508131362537552",
  integrations: [],
  sampleRate: 0.1,
});

const path = window.location.pathname;

const root = createRoot(document.getElementById("root"));

if (path.startsWith(`/unsubscription`)) {
  root.render(
    <React.StrictMode>
        <GlobalContext>
          <UnsubscriptionIterableRouter />
        </GlobalContext>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <GlobalContext>
          <App />
        </GlobalContext>
      </HelmetProvider>
    </React.StrictMode>
  );
}
